import { Check, X } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const FOR = [
  "You want to learn a defined trading Game Plan rather than constantly jumping between strategies.",
  "You understand trading involves risk and are willing to define that risk before entering.",
  "You want technology to support your process—not make promises for you.",
  "You want your execution measured instead of guessed.",
  "You're ready to treat execution as a trainable skill.",
  "You want accountability around following a written process.",
];

const NOT_FOR = [
  "You're looking for guaranteed profits or win rates.",
  "You want someone else to make every trading decision for you.",
  "You're searching for a get-rich-quick shortcut.",
  "You're unwilling to follow predefined risk.",
  "You want a magic indicator that removes uncertainty.",
  "You're unwilling to study and improve your own execution.",
];

export default function WhoThisIsFor() {
  return (
    <section data-testid="qualifier-section" className="border-t border-line bg-[#070809] py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <Reveal>
            <div className="mb-5 flex items-center justify-center gap-3 font-mono text-[11px] uppercase tracking-[0.25em] text-neon/90">
              <span className="h-px w-8 bg-neon/50" />
              The Standard
              <span className="h-px w-8 bg-neon/50" />
            </div>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="font-display text-3xl font-extrabold uppercase leading-[1.05] tracking-tight text-white sm:text-4xl lg:text-5xl">
              Built for <span className="glow-text-neon text-neon">Executors.</span>
              <br />
              Not for everyone.
            </h2>
          </Reveal>
        </div>

        <div className="mx-auto mt-16 grid max-w-5xl gap-4 lg:grid-cols-2">
          <Reveal delay={0.1} className="h-full">
            <div
              data-testid="qualifier-for-card"
              className="h-full rounded-lg border border-neon/40 bg-charcoal p-8 sm:p-10"
            >
              <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-neon">
                This is for you if
              </div>
              <ul className="mt-7 space-y-4">
                {FOR.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-sm leading-relaxed text-white">
                    <Check size={15} className="mt-0.5 shrink-0 text-neon" />
                    {f}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
          <Reveal delay={0.2} className="h-full">
            <div
              data-testid="qualifier-not-for-card"
              className="h-full rounded-lg border border-line bg-charcoal/50 p-8 sm:p-10"
            >
              <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-dim">
                This is not for you if
              </div>
              <ul className="mt-7 space-y-4">
                {NOT_FOR.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-sm leading-relaxed text-mist">
                    <X size={15} className="mt-0.5 shrink-0 text-risk/70" />
                    {f}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <div className="mx-auto mt-16 max-w-3xl text-center">
            <p className="font-display text-2xl font-extrabold uppercase leading-snug tracking-tight text-white sm:text-3xl">
              P.E.E. doesn't promise
              <br />
              to remove uncertainty.
            </p>
            <p className="glow-text-neon mt-3 font-display text-2xl font-extrabold uppercase leading-snug tracking-tight text-neon sm:text-3xl">
              It teaches you how
              <br />
              to operate within it.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
